import React from 'react';
import {PERIOD_TIME_UNIT_ENUM} from "../../../../../../../../enums/PeriodTimeUnitEnum";
import {CustomDatePicker} from "../../../../../../../../components/CustomDatePicker";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const DateRangeScope = ({ rule, updateRule, emptyFields, isValid = true, disabled }) => {
    return (
        <>
            <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 px-1'>
                <CustomDatePicker
                    id='dp_drs_start_date'
                    name={'startDate'}
                    onChange={(e) => updateRule('startDate', e)}
                    trans={'start_date'}
                    value={rule.startDate}
                    openTo={PERIOD_TIME_UNIT_ENUM.DAYS.key}
                    required={true}
                    emptyFields={emptyFields}
                    isValid={isValid}
                    isValidText={"end_date_cannot_be_before_start_date"}
                    disabled={disabled}
                />
            </div>
            <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 px-1'>
                <CustomDatePicker
                    id='dp_drs_end_date'
                    name={'endDate'}
                    onChange={(e) => updateRule('endDate', e)}
                    trans={'end_date'}
                    value={rule.endDate}
                    openTo={PERIOD_TIME_UNIT_ENUM.DAYS.key}
                    required={true}
                    emptyFields={emptyFields}
                    isValid={isValid}
                    isValidText={'end_date_cannot_be_before_start_date'}
                    minDate={rule.startDate}
                    disabled={disabled}
                />
            </div>
        </>
    );
};

export default DateRangeScope;
